import { connect } from 'react-redux'
import { DashboardComponent } from './DashboardComponent'
import {
    fetchDashboardPageData,
    logout,
    logoutDone
} from 'shared/store/kingdom/dashboard'
import { fetchPointsPageData } from 'shared/store/kingdom/points'
import { fetchCardPageData } from 'shared/store/kingdom/card'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import { kingdomCouponsSelector } from 'shared/store/kingdom/privileges'
import { featureCodes } from 'shared/utils'

const mapStateToProps = (state: RootState) => {
    const {
        kingdomDashboardPageState,
        kingdomPointsPageState,
        kingdomPrivilegesPageState,
        userState
    } = state
    const kingdomCoupons = kingdomCouponsSelector(state)
    const navigationState = state.router.location.state
    return {
        ...kingdomDashboardPageState,
        ...userState,
        pointInfos: kingdomPointsPageState.pointInfos,
        coupons: kingdomCoupons,
        couponsLoaded: kingdomPrivilegesPageState.dataLoaded,
        navigationState
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchDashboardData: () => d(fetchDashboardPageData()),
    fetchPointsData: () => d(fetchPointsPageData()),
    fetchCardData: () => d(fetchCardPageData()),
    logout: () => d(logout()),
    logoutDone: (params: { isGlobal: boolean }) => d(logoutDone(params))
})

const Dashboard = connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardComponent)

export { Dashboard }
